import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Post, PostsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class PostsDataService {

  private uri: string = `${environment.apiUrl}posts`;
  private cacheKey: string = 'posts.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getPost(id: number): Observable<Post|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getPosts(parameters: {[param: string]: string | string[]}): Observable<PostsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addPost(data: Post): Observable<Post|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addPosts(data: Post[]): Observable<Post[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updatePost(data: Post): Observable<Post|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updatePosts(data: Post[]): Observable<Post[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchPost(data: Post): Observable<Post|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchPosts(data: Post[]): Observable<Post[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deletePost(data: Post): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deletePosts(data: Post[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((post) => {
      ids.push(post.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
